// Colors reference tokens defined in tailwind.config.js (theme.extend.colors.palette.*)
//
// Deliberately NOT green/red: those already mean inflow/outflow on every money
// column of these tables, and a green "USD" chip sitting beside them would read
// as a positive amount. Sky vs amber are unused by the money columns, so the
// currency reads as a separate axis.
//
// Keys mirror CURRENCY_OPTIONS in DailyBankBalance.jsx and `Currency.choices` on
// backend/apps/bank_accounts/models.py — add a case here when a currency is added
// there, or it falls back to the neutral gray below.
const CURRENCY_CONFIG = {
  CAD: {
    bg: "bg-palette-sky-soft",
    text: "text-palette-sky-text",
    dot: "bg-palette-sky-badge",
  },
  USD: {
    bg: "bg-palette-amber-soft",
    text: "text-palette-amber-text",
    dot: "bg-palette-amber-badge",
  },
};

const FALLBACK = {
  bg: "bg-palette-gray-subtle",
  text: "text-palette-gray-heading",
  dot: "bg-palette-gray-placeholder",
};

export default function CurrencyBadge({ currency, className = "" }) {
  if (!currency) return <span className="text-palette-gray-placeholder">—</span>;
  const code = String(currency).toUpperCase();
  const cfg = CURRENCY_CONFIG[code] ?? FALLBACK;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${cfg.bg} ${cfg.text} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${cfg.dot}`} />
      {code}
    </span>
  );
}
